//This is for the mobile select dropdown options
class capabilitiesSelect extends HTMLElement {
  constructor() {
    super();

    this.capabilities = this.querySelectorAll('.capabilities-list li');
    this.capabilitiesContents = this.querySelectorAll('[data-tab-content]')
    this.select = this.querySelector('.capabilities-list-dropdown > select');
  }

  connectedCallback() {
    this.capabilities.forEach(el => el.addEventListener('click', this.onClickCapability.bind(this)));
    this.select.addEventListener('change', this.onChangeSelect.bind(this));
  }

  onClickCapability(evnt) {
    evnt.preventDefault();

    this._target = Array.from(this.capabilitiesContents)[evnt.currentTarget.dataset.index];
    this.capabilitiesContents.forEach(elemts => { elemts.classList.remove('active-capabilitie') });
    this.capabilities.forEach(el => el.classList.remove('active-capabilitie'));

    evnt.currentTarget.classList.add('active-capabilitie');
    this._target.classList.add('active-capabilitie');
  }

  onChangeSelect(evnt) {
    this._targetCapabilitie = Array.from(this.capabilitiesContents)[evnt.target.selectedIndex];
    this._target = evnt.target.options[evnt.target.selectedIndex];
    this.capabilitiesContents.forEach(elemts => { elemts.classList.remove('active-capabilitie') });
    Array.from(this.select.options).forEach(option => { option.classList.remove('active-capabilitie'); });
    this._target.classList.add('active-capabilitie');
    this._targetCapabilitie.classList.add('active-capabilitie');
  }
}

customElements.define('capabilities-list', capabilitiesSelect);

